import {
  AuditOutlined,
  DashboardOutlined,
  FileDoneOutlined,
  TableOutlined,
} from '@ant-design/icons'
import FeatherIcon from 'feather-icons-react'
import {
  BiBarcode,
  BiCalendar,
  BiCart,
  BiShoppingBag,
  BiWallet,
  BiWorld,
} from 'react-icons/bi'
import { FaRegCalendarAlt, FaRegCheckCircle, FaTiktok } from 'react-icons/fa'
import { FiPrinter, FiTruck } from 'react-icons/fi'
import { GoArrowSwitch } from 'react-icons/go'
import { GrStakeholder } from 'react-icons/gr'
import { RiRobotLine, RiTakeawayLine } from 'react-icons/ri'
import { TbLayoutGrid, TbStack2 } from 'react-icons/tb'
import { Link } from 'react-router-dom'
import PageUrls from '../../constants/page-urls'
import { EOrderStatus } from '../../types/order'
import { IMerchant } from '../../types/merchant'
import {
  isAllowAi,
  isAllowConnectPlatform,
  isAllowShopee,
  isAllowTikTok,
} from '../../constants/user'
import { IUser } from '../../types/user'

import store from 'store2'
import { JWT_TOKEN_NAME } from '../../constants/auth-key'

const orderChildren: any[] = [
  // {
  //   icon: <BiWorld size={28} />,
  //   abilityKey: 'salepageOrder',
  //   label: 'รายการ SalePage',
  //   status: EOrderStatus.SALEPAGE,
  // },
  {
    icon: <BiShoppingBag size={28} />,
    abilityKey: 'myOrder',
    label: 'รายการคำสั่งซื้อ',
    status: '',
  },

  {
    icon: <BiCart size={28} />,
    abilityKey: 'sendOrder',
    label: 'รายการรอส่งสินค้า',
    status: EOrderStatus.PENDING,
  },
  {
    icon: <FeatherIcon icon="x" />,
    abilityKey: 'cancelOrder',
    label: 'รายการยกเลิก',
    status: EOrderStatus.CANCLELLED,
  },
  {
    icon: <BiBarcode size={28} />,
    abilityKey: 'createdTracking',
    label: 'สร้างเลขพัสดุแล้ว',
    status: EOrderStatus.TRACKING,
  },
  {
    icon: <FeatherIcon icon="clock" />,
    abilityKey: 'returnProduct',
    label: 'สินค้าตีกลับ',
    status: EOrderStatus.RETURN,
  },
  {
    icon: <FeatherIcon icon="clock" />,
    abilityKey: 'returnedProduct',
    label: 'สินค้าตีกลับ (รับสินค้าแล้ว)',
    status: EOrderStatus.RETURNED,
  },

  {
    icon: <RiTakeawayLine size={23} />,
    abilityKey: 'transitOrder',
    label: 'รายการกำลังส่ง',
    status: EOrderStatus.TRANSIT,
  },
  {
    icon: <GrStakeholder size={23} />,
    abilityKey: 'deliveredOrder',
    label: 'รายการส่งสำเร็จ',
    status: EOrderStatus.DELIVERED,
  },
  {
    icon: <FaRegCheckCircle size={23} />,
    abilityKey: 'successOrder',
    label: 'รายการส่งแล้ว (กำหนดเอง)',
    status: EOrderStatus.SUCCESS,
  },
]

export const MenuItems = (merchant: any, ability: any, user: any) => {
  const hiddenChat = merchant.config?.openChat ? true : false
  const openAi = merchant.config?.openAi
  let hiddenAi = !openAi

  if (openAi) {
    hiddenAi = !ability.can('manage', 'Order', 'ai')
  }

  const hasTiktok = isAllowTikTok(merchant)
  const hasShopee = isAllowShopee(merchant)
  const hasAiBotSetting = isAllowAi(user as IUser)

  const hiddenAiBotSetting = !hasAiBotSetting
  const accessToken = store.get(JWT_TOKEN_NAME)
  const tobibotUrl = `${process.env.REACT_APP_TOBIBOT_URL}?token=${accessToken}`

  return [
    {
      label: 'เมนูหลัก',
      key: 'main',
      icon: null,
      children: [
        {
          key: PageUrls.Home,
          icon: <DashboardOutlined />,
          label: <Link to={PageUrls.Home}>ภาพรวมระบบ</Link>,
        },
      ],
      type: 'group',
    },
    // {
    //   label: 'Salepage',
    //   key: 'salepage',
    //   icon: null,
    //   children: [
    //     {
    //       key: PageUrls.Salepage.Index,
    //       icon: <FeatherIcon icon="file-text" />,
    //       label: <Link to={PageUrls.Salepage.Index}>รายการหน้า Salepage</Link>,
    //     },
    //     {
    //       key: PageUrls.Orders.SalePage,
    //       icon: <BiWorld size={28} />,
    //       label: (
    //         <Link to={PageUrls.Orders.SalePage}>คำสั่งซื้อ Salepage</Link>
    //       ),
    //     },
    //   ],
    //   type: 'group',
    // },
    {
      label: 'รายการติดตามลูกค้า (CRM)',
      key: 'crm',
      icon: null,
      hidden: merchant?.config?.openCRM ? !ability.can('manage', 'CRM') : true,
      children: [
        {
          key: PageUrls.CRM.Pipeline,
          icon: <FeatherIcon icon="sliders" />,
          hidden: !ability.can('manage', 'CRM', 'pipeline'),
          label: <Link to={PageUrls.CRM.Pipeline}>Lead Pipeline</Link>,
        },
        {
          key: PageUrls.CRM.Lead.Import,
          icon: <FeatherIcon icon="upload" />,
          hidden: !ability.can('manage', 'CRM', 'importLead'),
          label: (
            <Link to={PageUrls.CRM.Lead.Import}>นำเข้า Lead จากคำสั่งซื้อ</Link>
          ),
        },
        {
          key: PageUrls.CRM.Lead.List,
          icon: <FeatherIcon icon="users" />,
          hidden: !ability.can('manage', 'CRM', 'allFollow'),
          label: <Link to={PageUrls.CRM.Lead.List}>รายการติดตามทั้งหมด</Link>,
        },
        {
          key: PageUrls.CRM.Lead.Cancel,
          icon: <FeatherIcon icon="trash-2" />,
          hidden: !ability.can('manage', 'CRM', 'cancelFollow'),
          label: (
            <Link to={PageUrls.CRM.Lead.Cancel}>รายการติดตาม (ยกเลิก)</Link>
          ),
        },
        {
          key: PageUrls.CRM.Lead.Follow,
          icon: <FeatherIcon icon="bell" />,
          hidden: !ability.can('manage', 'CRM', 'notificationFollow'),
          label: (
            <Link to={PageUrls.CRM.Lead.Follow}>
              รายการแจ้งเตือนติดตามลูกค้า
            </Link>
          ),
        },
        {
          key: PageUrls.CRM.Lead.Calender,
          icon: <FeatherIcon icon="calendar" />,
          hidden: !ability.can('manage', 'CRM', 'calendarFollow'),
          label: (
            <Link to={PageUrls.CRM.Lead.Calender}>ปฎิทินติดตามลูกค้า</Link>
          ),
        },
        {
          key: PageUrls.CRM.Lead.Notification,
          icon: <FeatherIcon icon="bell" />,
          hidden: !ability.can('manage', 'CRM', 'reportFollow'),
          label: (
            <Link to={PageUrls.CRM.Lead.Notification}>
              รายงานสถานะการติดตาม Lead
            </Link>
          ),
        },
      ],
      type: 'group',
    },
    {
      label: 'สร้างรายการสั่งซื้อ',
      key: 'order',
      icon: null,
      hidden: !ability.can('manage', 'CreateOrder'),
      children: [
        {
          key: PageUrls.Orders.Create,
          icon: <AuditOutlined />,
          hidden: !ability.can('manage', 'CreateOrder', 'createOrder'),
          label: <Link to={PageUrls.Orders.Create}>สร้างคำสั่งซื้อ</Link>,
        },
        // {
        //   key: PageUrls.Orders.QuickCreate,
        //   icon: <FileDoneOutlined />,
        //   hidden: !ability.can('manage', 'CreateOrder', 'quickOrder'),
        //   label: (
        //     <Link to={PageUrls.Orders.QuickCreate}>สร้างคำสั่งซื้อ (ด่วน)</Link>
        //   ),
        // },
        {
          key: PageUrls.Orders.QuickCreateOld,
          icon: <FileDoneOutlined />,
          hidden: !ability.can('manage', 'CreateOrder', 'quickOrderV1'),
          label: (
            <Link to={PageUrls.Orders.QuickCreateOld}>
              สร้างคำสั่งซื้อ (ด่วน)
            </Link>
          ),
        },
        {
          key: PageUrls.Orders.ImportExcel,
          icon: <TableOutlined />,
          hidden: !ability.can('manage', 'CreateOrder', 'importExcel'),
          label: <Link to={PageUrls.Orders.ImportExcel}>Import Excel</Link>,
        },
      ],
      type: 'group',
    },
    {
      label: 'รายการคำสั่งซื้อ AI',
      key: 'order-list',
      icon: null,
      hidden: hiddenAi,
      children: [
        {
          key: PageUrls.Ai.notify,
          icon: <FeatherIcon icon="bell" />,
          hidden: hiddenAi,
          label: <a href={PageUrls.Ai.notify}>รายการแจ้งเตือน</a>,
        },
        {
          key: PageUrls.Orders.Ai,
          icon: <FeatherIcon icon="codesandbox" />,
          hidden: hiddenAi,
          label: <a href={PageUrls.Orders.Ai}>รายการคำสั่งซื้อ</a>,
        },
        {
          key: 'ai-bot-setting',
          icon: <FeatherIcon icon="tool" />,
          hidden: hiddenAiBotSetting,
          label: (
            <a href={tobibotUrl} target="_blank">
              ตั้งค่าแชทบอท AI
            </a>
          ),
        },
      ],
      type: 'group',
    },
    {
      label: 'รายการคำสั่งซื้อ',
      key: 'order-list',
      icon: null,
      hidden: !ability.can('manage', 'Order'),
      children: [
        // {
        //   key: PageUrls.Orders.Ai,
        //   icon: <FeatherIcon icon="codesandbox" />,
        //   hidden: hiddenAi,
        //   label: <a href={PageUrls.Orders.Ai}>รายการคำสั่งซื้อ AI</a>,
        // },
        {
          key: PageUrls.Orders.Telesale,
          icon: <FeatherIcon icon="phone-call" />,
          hidden: !ability.can('manage', 'Order', 'telesaleOrder'),
          label: (
            <a href={PageUrls.Orders.Telesale}>รายการคำสั่งซื้อ Telesale</a>
          ),
        },
        ...orderChildren.map((child) => ({
          key: `/orders/${child.status}`,
          icon: child.icon,
          hidden: !ability.can('manage', 'Order', child.abilityKey),
          label: (
            <a href={`${PageUrls.Orders.Index}/${child.status}`}>
              {child.label}
            </a>
          ),
        })),
      ],
      type: 'group',
    },
    {
      label: 'รายการคำสั่งซื้อ จาก Platform',
      key: 'order-list-platform',
      icon: null,
      hidden: (!hasTiktok && !hasShopee) || !ability.can('manage', 'Platform'),
      children: [
        {
          key: `${PageUrls.Platforms.Tiktok}`,
          icon: <FaTiktok />,
          // ซ่อนถาวร — ดึงออเดอร์สดจาก TikTok ไม่ได้ใช้แล้ว
          // field 'tiktok' ถูกตัดออกจากหน้าตั้งค่าสิทธิ์แล้ว ถ้าจะเปิดเมนูนี้กลับมา
          // ต้องเพิ่ม field เข้า AbilitiesPermissions ใหม่ก่อน
          hidden: true,
          label: (
            <Link to={`${PageUrls.Platforms.Tiktok}`}>
              รายการคำสั่งซื้อ จาก TikTok
            </Link>
          ),
        },
        {
          key: `${PageUrls.Platforms.TiktokSalesReport}`,
          icon: <BiWallet size={23} />,
          hidden:
            !hasTiktok || !ability.can('manage', 'Platform', 'tiktokReport'),
          label: (
            <Link to={`${PageUrls.Platforms.TiktokSalesReport}`}>
              รายงานยอดขายจาก TikTok
            </Link>
          ),
        },
        {
          key: `${PageUrls.Platforms.ShopeeSalesReport}`,
          icon: <BiWallet size={23} />,
          hidden:
            !hasShopee || !ability.can('manage', 'Platform', 'shopeeReport'),
          label: (
            <Link to={`${PageUrls.Platforms.ShopeeSalesReport}`}>
              รายงานยอดขายจาก Shopee
            </Link>
          ),
        },
      ],
      type: 'group',
    },
    {
      label: 'หมายเลขพัสดุ',
      key: 'Tracking',
      icon: null,
      hidden: !ability.can('manage', 'Tracking'),
      children: [
        {
          key: PageUrls.Tracking,
          icon: <FiTruck size={23} />,
          hidden: !ability.can('manage', 'Tracking', 'create'),
          label: (
            <Link to={PageUrls.Tracking}>สร้างหมายเลขพัสดุ / พิมพ์ใบลาเบล</Link>
          ),
        },
        {
          key: PageUrls.TrackingPrinted,
          icon: <FiPrinter size={23} />,
          hidden: !ability.can('manage', 'Tracking', 'printed'),
          label: (
            <Link to={PageUrls.TrackingPrinted}>ประวัติการพิมพ์ใบลาเบล</Link>
          ),
        },
      ],
      type: 'group',
    },
    {
      label: 'รายการสินค้า',
      key: 'product',
      icon: null,
      hidden: !ability.can('manage', 'Product'),
      children: [
        {
          key: PageUrls.Product,
          icon: <BiBarcode size={23} />,
          hidden: !ability.can('manage', 'Product', 'productList'),
          label: <Link to={PageUrls.Product}>รายการสินค้า</Link>,
        },
        {
          key: PageUrls.Stock,
          icon: <GoArrowSwitch size={23} />,
          hidden: !ability.can('manage', 'Product', 'reportProduct'),
          label: <Link to={PageUrls.Stock}>รายงาน ลด-เพิ่ม สินค้า</Link>,
        },
        {
          key: PageUrls.Category,
          icon: <TbLayoutGrid size={23} />,
          hidden: !ability.can('manage', 'Product', 'category'),
          label: <Link to={PageUrls.Category}>หมวดหมู่สินค้า</Link>,
        },
        {
          key: PageUrls.ProductGroup,
          icon: <TbStack2 size={23} />,
          hidden: !ability.can('manage', 'Product', 'productGroup'),
          label: <Link to={PageUrls.ProductGroup}>กลุ่มสินค้า</Link>,
        },
      ],
      type: 'group',
    },
    {
      label: 'ค่าใช้จ่าย',
      key: 'expense',
      icon: null,
      hidden: !ability.can('manage', 'Expense'),
      children: [
        {
          key: PageUrls.Expenses,
          icon: <FeatherIcon icon="dollar-sign" />,
          hidden: !ability.can('manage', 'Expense', 'expense'),
          label: <Link to={PageUrls.Expenses}>รายการค่าใช้จ่าย</Link>,
        },
      ],
      type: 'group',
    },
    {
      label: 'รายงาน',
      key: 'report',
      icon: null,
      hidden: !ability.can('manage', 'Report'),
      children: [
        {
          key: PageUrls.Report.DailySales,
          icon: <FaRegCalendarAlt size={23} />,
          hidden: !ability.can('manage', 'Report', 'sale'),
          label: <Link to={PageUrls.Report.DailySales}>รายงานยอดขาย</Link>,
        },
        {
          key: PageUrls.Report.DailyOrders,
          icon: <FeatherIcon icon="shopping-bag" />,
          hidden: !ability.can('manage', 'Report', 'order'),
          label: <Link to={PageUrls.Report.DailyOrders}>รายงานการสั่งของ</Link>,
        },
        {
          key: PageUrls.Report.Index,
          icon: <FeatherIcon icon="clock" />,
          hidden: !ability.can('manage', 'Report', 'daily'),
          label: <Link to={PageUrls.Report.Index}>รายงานประจำวัน</Link>,
        },
        {
          key: PageUrls.Report.SendItems,
          icon: <BiShoppingBag size={28} />,
          hidden: !ability.can('manage', 'Report', 'delivery'),
          label: <Link to={PageUrls.Report.SendItems}>รายงานส่งของ</Link>,
        },
        {
          key: PageUrls.Report.Calendar,
          icon: <BiCalendar size={28} />,
          hidden: !ability.can('manage', 'Report', 'calendar'),
          label: <Link to={PageUrls.Report.Calendar}>ปฏิทินรายงานส่งของ</Link>,
        },
        {
          key: PageUrls.Report.Commission,
          icon: <BiWallet size={23} />,
          hidden:
            !ability.can('manage', 'Report', 'commission') &&
            !ability.can('manage', 'Report', 'commissionLimit'),
          label: <Link to={PageUrls.Report.Commission}>รายงานคอมมิชชั่น</Link>,
        },
        {
          key: PageUrls.Report.CommissionCancelled,
          icon: <BiWallet size={23} />,
          hidden: !ability.can('manage', 'Report', 'commission-cancelled'),
          label: (
            <Link to={PageUrls.Report.CommissionCancelled}>
              รายงานยกเลิกคอมมิชชั่น
            </Link>
          ),
        },
        {
          key: PageUrls.Report.CodChecker,
          icon: <FeatherIcon icon="check-circle" />,
          hidden: !ability.can('manage', 'Report', 'cod'),
          label: <Link to={PageUrls.Report.CodChecker}>ตรวจสอบยอด COD</Link>,
        },
        {
          key: PageUrls.Report.Custormer,
          icon: <FeatherIcon icon="users" />,
          hidden: !ability.can('manage', 'Report', 'customer'),
          label: (
            <Link to={PageUrls.Report.Custormer}>
              รายงานยอดขายลูกค้ารายบุคคล
            </Link>
          ),
        },
      ],
      type: 'group',
    },
    // {
    //   label: 'Facebook',
    //   key: 'facebook',
    //   icon: null,
    //   hidden: !ability.can('manage', 'Facebook'),
    //   children: [
    //     {
    //       key: PageUrls.Chat.Facebook,
    //       icon: <FacebookOutlined />,
    //       // hidden: !ability.can('manage', 'Chat'),
    //       label: <Link to={PageUrls.Facebook.UserInfo}>facebook</Link>,
    //     },
    //   ],
    //   type: 'group',
    // },
    /*
        {
          label: 'Marketplace',
          key: 'marketplace',
          icon: null,
          hidden: !ability.can('manage', 'DashboardOverviewReport'),
          children: [
            {
              key: PageUrls.Marketplace.Shope.Shopee.Order,
              icon: (
                <img
                  src={ImageLinks.LOGO_CIRCLE_SHOPEE}
                  style={{ width: '20px', height: '20px' }}
                  alt="shopee"
                />
              ),
              // hidden: !ability.can('manage', 'Chat'),
              label: (
                <Link to={PageUrls.Marketplace.Shope.Shopee.Order}>Shopee</Link>
              ),
            },
            {
              key: PageUrls.Marketplace.Shope.Tiktok.Order,
              icon: (
                <img
                  src={ImageLinks.LOGO_CIRCLE_TIKTOK}
                  style={{ width: '20px', height: '20px' }}
                  alt="tiktok"
                />
              ),
              // hidden: !ability.can('manage', 'Chat'),
              label: (
                <Link to={PageUrls.Marketplace.Shope.Tiktok.Order}>Tiktok</Link>
              ),
            },
            {
              key: PageUrls.Marketplace.Shope.Lazada.Order,
              icon: (
                <img
                  src={ImageLinks.LOGO_CIRCLE_LAZADA}
                  style={{ width: '20px', height: '20px' }}
                  alt="lazada"
                />
              ),
              // hidden: !ability.can('manage', 'Chat'),
              label: (
                <Link to={PageUrls.Marketplace.Shope.Lazada.Order}>Lazada</Link>
              ),
            },
            {
              key: PageUrls.Marketplace.Shope.LineMyShop.Order,
              icon: (
                <img
                  src={ImageLinks.LOGO_LINE_MY_SHOP_HORIZONTAL}
                  style={{ width: '20px', height: '20px' }}
                  alt="line my shop"
                />
              ),
              // hidden: !ability.can('manage', 'Chat'),
              label: (
                <Link to={PageUrls.Marketplace.Shope.LineMyShop.Order}>
                  Line My Shop
                </Link>
              ),
            },
          ],
          type: 'group',
        },
        */
    {
      label: 'รายงานผู้ใช้งาน',
      key: 'user',
      icon: null,
      hidden: !ability.can('manage', 'User'),
      children: [
        {
          key: PageUrls.Users,
          icon: <FeatherIcon icon="user" />,
          hidden: !ability.can('manage', 'User', 'userList'),
          label: <Link to={PageUrls.Users}>รายงานผู้ใช้งาน</Link>,
        },
        // {
        //   key: PageUrls.Merchant,
        //   icon: <FeatherIcon icon="users" />,
        //   hidden: !ability.can('manage', 'all'),
        //   label: <Link to={PageUrls.Merchant}>รายงานร้านค้า</Link>,
        // },
        {
          key: PageUrls.Customer.BlackList,
          icon: <FeatherIcon icon="user-x" />,
          hidden: !ability.can('manage', 'User', 'blackList'),
          label: (
            <Link to={PageUrls.Customer.BlackList}>
              รายงานลูกค้า Black List
            </Link>
          ),
        },
      ],
      type: 'group',
    },
    // {
    //   label: 'แชท',
    //   key: 'chat',
    //   icon: null,
    //   hidden: !hiddenChat,
    //   children: [
    //     {
    //       key: PageUrls.Chats,
    //       icon: <FeatherIcon icon="user" />,
    //       label: <Link to={PageUrls.Chats}>แชท</Link>,
    //     },
    //     {
    //       key: PageUrls.Broadcast,
    //       icon: <FeatherIcon icon="user" />,
    //       label: <Link to={PageUrls.Broadcast}>บอร์ดแคส</Link>,
    //     },
    //   ],
    //   type: 'group',
    // },
    {
      label: 'ตั้งค่า',
      key: 'setting',
      icon: null,
      hidden: !ability.can('manage', 'Setting'),
      children: [
        {
          key: PageUrls.Setting.DistributionChannels,
          icon: <FeatherIcon icon="shopping-cart" />,
          hidden: !ability.can('manage', 'Setting', 'saleChannel'),
          label: (
            <Link to={PageUrls.Setting.DistributionChannels}>
              ช่องทางการขาย
            </Link>
          ),
        },
        {
          key: PageUrls.Setting.Index,
          icon: <FeatherIcon icon="settings" />,
          hidden: !ability.can('manage', 'Setting', 'generalSetting'),
          label: <Link to={PageUrls.Setting.Index}>ตั้งค่าทั่วไป</Link>,
        },
        {
          key: PageUrls.Setting.Address,
          icon: <FeatherIcon icon="map-pin" />,
          hidden: !ability.can('manage', 'Setting', 'addressBook'),
          label: <Link to={PageUrls.Setting.Address}>สมุดที่อยู่</Link>,
        },
        {
          key: PageUrls.Setting.ChatIntegrations,
          icon: <FeatherIcon icon="link" />,
          hidden: !hiddenChat || !isAllowConnectPlatform(user),
          label: (
            <Link to={PageUrls.Setting.ChatIntegrations}>
              เชื่อมต่อ Social Media
            </Link>
          ),
        },
        {
          key: PageUrls.Setting.ShippingSettings,
          icon: <FiTruck size={23} />,
          hidden: !ability.can('manage', 'Setting', 'shipping'),
          label: (
            <Link to={PageUrls.Setting.ShippingSettings}>ตั้งค่าขนส่ง</Link>
          ),
        },
      ],
      type: 'group',
    },
  ]
}
